/**
 * Returns true if number is numeric
 * @param {mixed} n
 */
export default function(n) {
    return !isNaN(+n) && isFinite(n)
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/isNumeric.js